import React, { useEffect } from "react";
import { Button } from "_c/button";
import { ButtonGroup } from "./styled";
import { analyticsAction } from "@/utils/analytics";

const AfterStepInfo = ({ img, header, text, buttons, analytics }) => {
  useEffect(() => {
    if (analytics) {
      analyticsAction({
        category: "wizard",
        action: analytics,
      });
    }
  }, [analytics]);
  return (
    <div
      css={`
        text-align: center;
      `}
    >
      <img
        draggable="false"
        css={`
          width: 360px;
          height: 360px;
          object-fit: cover;
          display: inline-block;
          border-radius: 12px;
          @media (max-width: 400px) {
            width: 310px;
            height: 310px;
            @supports (aspect-ratio: 1 / 1) {
              width: 100%;
              height: auto;
              aspect-ratio: 1 / 1;
            }
          }
        `}
        src={img}
      />
      <h2
        css={`
          color: var(--font-color-emp);
          font-size: 17px;
          font-weight: 700;
          margin-top: 10px;
          margin-bottom: 10px;
        `}
      >
        {header}
      </h2>
      <p
        css={`
          margin: 0;
          color: var(--font-color-accent);
          line-height: 1.3;
        `}
      >
        {text}
      </p>
      <ButtonGroup>
        {buttons.map((btn) => (
          <Button onClick={btn.onClick} small {...btn.props}>
            {btn.text}
          </Button>
        ))}
      </ButtonGroup>
    </div>
  );
};

export default AfterStepInfo;
